import React from 'react';

function About() {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="bg-white rounded-lg shadow p-8">
        <h1 className="text-3xl font-bold mb-6 text-center">关于我们</h1>
        <div className="prose max-w-none">
          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            本站由中国铁路沈阳局集团有限公司正式职工开发、维护、运行，服务于全国铁路职工，如有相关问题以及交流合作事宜，欢迎联系微信。
          </p>
          <div className="bg-blue-50 rounded-lg p-6 mt-8">
            <p className="text-center text-xl font-semibold text-blue-800">
              站长微信号：work_hj
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
